<template>
  <div>
    <h1 class="title ml-4 pl-2 ">{{ $t("asset-group.degree-of-criticality") }}</h1>
    <b-dropdown split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="mr-4 m-2 text-right float-right">
      <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
    </b-dropdown>
    <div class="table-wrapper">
      <div class="table-reponsive pt-2">
        <table>
          <thead>
            <tr>
              <th>{{ $t("asset-group-category.text") }}</th>
              <th>{{ $t("asset-group.no") }}</th>
              <th>{{ $t("asset-group.name") }}</th>
              <th>{{ $t("asset-group-survey.admin") }}</th>

              <th>{{ $t("asset-group-survey.assesment-criterias.privacy") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.entirety") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.accessibility") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.effected-people-count") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.social-Results") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.corporate-results") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.sectoral-effect") }}</th>
              <th>{{ $t("asset-group-survey.assesment-criterias.dependent-entities") }}</th>
              <th>{{ $t("asset-group-survey.point") }}</th>
              <th>{{ $t("asset-group.degree-of-criticality") }}</th>
              <th class="col-10">{{ $t("common.note") }}</th>
              <th>{{ $t("asset-group-survey.complated-date") }}</th>
              <th>
                <a href="javascript:;" @click="toggleFilter">
                  <span v-if="filterEnabled" class="text-warning">
                    <i class="bx bxs-filter-alt"></i>
                    {{ $t("common.filters-hide") }}
                  </span>
                  <span v-else class="text-muted">
                    <i class="bx bxs-filter-alt"></i>
                    {{ $t("common.filters-show") }}
                  </span>
                </a>
              </th>
            </tr>
            <tr v-if="filterEnabled">
              <th>
                <filter-select
                  style="min-width: 150px;"
                  id="assetGroupCategoryFilter"
                  ref="assetGroupCategoryFilter"
                  :placeholder="$t('asset-group-category.text')"
                  :multiple="false"
                  @filter="onAssetGroupCategorySearch"
                  :selected="assetGroupCategoryFilter"
                  @changed="onAssetGroupCategorySelect"
                />
              </th>
              <th><input :placeholder="$t('task.no-in-short')" class="form-control" v-model="noFilter" type="text" /></th>
              <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="pagination && pagination.docs.length > 0">
            <tr v-for="item in pagination.docs" :key="item._id" class="hider">
              <td>
                <span v-if="item.assetGroupCategory">{{ item.assetGroupCategory.name | translate }}</span>
              </td>
              <td>
                <span>{{ item.no }}</span>
              </td>
              <td>
                <span>{{ item.name | translate }}</span>
              </td>
              <td>
                <span>{{ item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.admins.length ? item.assetGroupSurveyGroup.admins[0].account.name : "" }}</span>
              </td>

              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.privacy }}</span>
                <span v-else-if="item.assesmentCriterias">{{ item.assesmentCriterias.privacy }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.entirety }}</span>
                <span v-else-if="item.assesmentCriterias">{{ item.assesmentCriterias.entirety }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.accessibility }}</span>
                <span v-else-if="item.assesmentCriterias">{{ item.assesmentCriterias.accessibility }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.effectedPeopleCount }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.socialResults }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.corporateResults }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.sectoralEffect }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ item.assetGroupSurveyGroup.adminResults.dependentEntities }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.adminResults">{{ totalPoints(item.assetGroupSurveyGroup.adminResults) }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup">{{ item.criticalityLevel }}</span>
              </td>
              <td>
                <span>{{ item.description | translate }}</span>
              </td>
              <td>
                <span v-if="item.assetGroupSurveyGroup">{{ item.assetGroupSurveyGroup.complatedDate | date }}</span>
              </td>
              <td>
                <div
                  v-if="item.assetGroupSurveyGroup && item.assetGroupSurveyGroup.status == 'DONE'"
                  class="hand text-success"
                  v-b-tooltip.hover
                  :title="$t('asset-group-survey.view-result')"
                  @click="redirectToSurvey(item.assetGroupSurveyGroup)"
                >
                  <i class="bx bx-log-in-circle font-size-24 align-middle"></i> <span class="mb-1 d-inline-block"></span>
                </div>
                <div class="hand text-primary" v-else v-b-tooltip.hover :title="$t('asset-group-survey.view-survey')" @click="redirectToSurveyGroup(item)">
                  <i class="bx bx-log-in-circle font-size-24 align-middle"></i> <span class="mb-1 d-inline-block"></span>
                </div>
                <span v-b-tooltip.hover :title="$t('asset-group.edit-description')" class="hand text-main mr-1" @click="editAssetGroupDescription(item)">
                  <i class="bx bx-pencil align-middle"></i
                ></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="16">
                <empty v-if="!pagination || pagination.docs.length == 0">
                  <h5 class="text-center">
                    {{ $t("asset-group.empty") }}
                  </h5>
                </empty>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="pagination" class="d-flex ">
          <template>
            <div class="d-flex justify-content-center my-3">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="5" size="sm"></b-pagination>
            </div>
          </template>
        </div>
        <b-modal :id="'modal-add-asset-group-description'" size="lg" centered :title="$t('asset-group.description')" hide-footer>
          <div>
            <sweet-textarea
              v-model="assetGroupDescription"
              :isValid="!$v.assetGroupDescription.$error"
              @input="$v.assetGroupDescription.$touch()"
              type="text"
              layout="vertical"
              :placeholder="$t('common.description')"
              :label="$t('asset-group.description')"
              :rows="9"
            />

            <div class="text-right">
              <sweet-button
                @click="saveAssetGroupDescription()"
                :invalid="$v.assetGroupDescription.$invalid"
                variant="success"
                icon="mdi mdi-check"
                size="sm"
                buttonClass="ml-2 mt-4"
              >
                {{ $t("common.save") }}
              </sweet-button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";

export default {
  components: { SweetTextarea },

  data() {
    return {
      assetGroupCount: undefined,
      assetGroupDescription: undefined,
      editedAssetGroup: undefined,
      criticalityLevelDetermination: false,

      filterEnabled: false,
      assetGroupCategoryFilter: undefined,
      noFilter: undefined,
      nameFilter: undefined,

      request: {
        options: { page: 1, limit: 15, sort: { assetGroupCategory: 1, no: 1 } },
        query: {}, // TKP-27: varlık grubunda `status` alanı yok — eskiden sessizce düşüyordu, bekçi 400 veriyor
      },
    };
  },
  beforeDestroy() {},
  computed: {
    pagination() {
      return this.$store.getters[`organizationAssetGroupInventory/pagination`];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchComplatedSurveys());
      },
    },
    noFilter(n, o) {
      if (n) {
        const isNumber = !isNaN(n);
        if (!isNumber) {
          this.clearNoFilter();
        }
        this.request.query = { ...this.request.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };
      } else {
        this.clearNoFilter();
      }
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  validations: {
    assetGroupDescription: {
      required,
    },
    assetGroupCount: {
      required,
    },
  },
  methods: {
    clearNoFilter() {
      this.request.query["no"] = null;
      delete this.request.query["no"];
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 14, sort: { assetGroupCategory: 1, no: 1 } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },
    async onAssetGroupCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationAssetGroupCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAssetGroupCategorySelect(assetGroupCategory) {
      if (!assetGroupCategory) {
        this.request.query["assetGroupCategory"] = undefined;
        delete this.request.query["assetGroupCategory"];
        return;
      }
      this.request.query = {
        ...this.request.query,
        assetGroupCategory: { value: assetGroupCategory._id, isObject: true },
      };
    },
    editAssetGroupDescription(item) {
      this.assetGroupDescription = this.$options.filters.translate(item.description);
      this.editedAssetGroup = item;
      this.$root.$emit("bv::show::modal", "modal-add-asset-group-description");
    },
    async saveAssetGroupDescription() {
      try {
        await this.$store.dispatch("organizationAssetGroupInventory/updateAssetGroupDescription", { id: this.editedAssetGroup._id, description: this.assetGroupDescription });

        this.$toast.success(this.$t("common.saved"));

        await this.fetchComplatedSurveys();

        this.$root.$emit("bv::hide::modal", "modal-add-asset-group-description");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    redirectToSurvey(item) {
      this.$router.push(`/ddo/asset-group/${item.assetGroup}/survey/${item._id}/results`);
    },
    redirectToSurveyGroup(item) {
      this.$router.push(`/ddo/asset-group/${item._id}/survey`);
    },
    totalPoints(item) {
      return Object.values(item)
        .filter((value) => typeof value === "number")
        .reduce((acc, curr) => Number(acc) + Number(curr), 0);
    },

    async fetchComplatedSurveys() {
      await this.$store.dispatch("organizationAssetGroupInventory/paginate", this.request);
    },
    async downloadExcel() {
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        const { data: file } = await this.$store.dispatch(`organizationAssetGroup/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../task/tasks.scss");
tr td {
  text-align: center;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>
